<template>
  <div class="min-h-screen flex place-items-center justify-center">
    <IconSpinner class="animate-spin w-12 h-12" />
  </div>
</template>

<script setup>
import IconSpinner from "@/components/icons/IconSpinner.vue";
</script>